import React from 'react';
import styled from 'styled-components';
import Button from '../Button';
import { RestorativeProgram } from '../../services/Restorative';
import RestorativeProgramFilter from './RestorativeProgramFilter';
import Searchbox from '../Searchbox';

interface HeaderProps {
  restorativePrograms: RestorativeProgram[];
  onSelectProgram: (programId: number) => void;
  onAddResident: () => void;
  updateSearchQuery: (query: string) => void;
}

const AddPlayerButton = styled(Button)(({ theme }) => {
  return `
  margin-left: 15px;
  align-items: center;
  justify-content: center;
  font-size: ${theme.new.type.size[16]}
`;
});

const Container = styled.div`
  text-align: right;
  margin-bottom: 20px;
`;

const PlusIcon = styled.span`
  margin-right: 5px;
`;

const Header: React.FC<HeaderProps> = ({ onSelectProgram, onAddResident, restorativePrograms, updateSearchQuery }) => {
  return (
    <Container>
      <Searchbox
        label="Search residents"
        id="search-residents"
        onSearch={(query) => {
          updateSearchQuery(query);
        }}
        placeholder="Search Residents"
      />
      <RestorativeProgramFilter programs={restorativePrograms} onSelectProgram={onSelectProgram} />
      <AddPlayerButton onClick={onAddResident} rounded={true}>
        <PlusIcon>+</PlusIcon> Add new resident
      </AddPlayerButton>
    </Container>
  );
};

export default Header;
